import React from "react";
import downloadScreen from "../assets/images/Mobile-Screen.png";
import googlePlayStore from "../assets/images/Google-Play-Store.png";
import applerPlayStore from "../assets/images/Apple-Play-Store.png";

const Downloads = () => {
  return (
    <div className="w-full md:w-981 flex justify-center h-auto md:h-100 bg-[#eeeeee]">
      <div className="downloads-container flex flex-col md:flex-row justify-center items-center">
        <div className="p-5 md:p-10 mr-0 md:mr-20">
          <img
            src={downloadScreen}
            alt="Shadow"
            width={300}
            className="h-[572px] download-img"
          />
        </div>
        <div className="text-center md:text-left pb-4 sm:pb-8">
          <h2 className="text-lg font-extrabold">
            <span className="font-bold text-2xl md:text-4xl">Download </span>
            <span className="font-bold text-2xl md:text-4xl">Home </span>
            <span className="font-bold text-2xl md:text-4xl text-[#f16c7d]">
              Fit{" "}
            </span>
            <span className="font-bold text-2xl md:text-4xl">Pro.</span>
          </h2>
          <div className="flex mt-4 justify-center sm:justify-start">
            <div className="inline-block mr-2">
              <a
                href="https://play.google.com/store/apps/details?id=com.sstechsystem.homefitpro"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={googlePlayStore}
                  alt="Google Play Store"
                  className="h-[35px] w-[120px] sm:h-[55px] sm:w-[170px]"
                />
              </a>
            </div>
            <div className="inline-block">
              <a
                href="https://apps.apple.com/us/app/home-fit-pro/id6470997290"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={applerPlayStore}
                  alt="Apple App Store"
                  className="h-[35px] w-[120px] sm:h-[55px] sm:w-[170px]"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Downloads;
